<template>
  <i :class="`color-${status}`">{{ text }}</i>
</template>
<script>

export default {
  name: "StatusValue",
  props: {
    text: {
      type: String,
      required: true
    },
    status: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.color--1 {
  color: #000;
}

.color-0 {
  color: #FAAD14;
  // color: #00f;
}

.color-1 {
  color: #f00;
}

.color-2 {
  color: #0f0;
}
</style>
